import * as React from 'react';

import Page from 'components/page/Page';

import SOVHeaderPageConsumerInsights from 'modules/insights/sov/components/header/consumer-insights/SOVHeaderPageConsumerInsights';
import SOVBannerConsumerInsights from 'modules/insights/sov/components/banners/consumer-insights/SOVBannerConsumerInsights';

import { __t, applyTranslations } from 'utils/language';

import './sov-request-access-page.scss';

applyTranslations(require('modules/insights/sov/components/banners/consumer-insights/sov-banner-consumer-insights.i18n.json'));

type Props = {
  onFieldChange: (name: string, value: string) => void,
  onSubmit: () => void
};

const MSG_KEY = 'sov_banner_consumer_insights';

const SOVRequestAccessPage = ({
  onFieldChange,
  onSubmit
}: Props): JSX.Element => (
  <Page
    documentTitle={__t(`${MSG_KEY}.page_title`)}
  >
    <div className="sov-request-access-page">
      <div className="sov-request-access-page__page-header">
        <SOVHeaderPageConsumerInsights
          reportType="instagram"
        />
      </div>
      <SOVBannerConsumerInsights
        onFieldChange={onFieldChange}
        onSubmit={onSubmit}
      />
    </div>
  </Page>
);

export default SOVRequestAccessPage;
